import {Singleton} from "../../base/singleton";

enum HeaderState {
    OPEN = 'open',
    COLLAPSED = 'collapsed',
    HIDDEN = 'hidden',
}

export class HeaderController extends Singleton {
    private header: HTMLElement;
    private headerStateAttribute: string = 'data-menu-header-state';
    private state: HeaderState = HeaderState.OPEN;

    protected constructor() {
        super();
        this.header = document.querySelector('[data-menu-header]') as HTMLElement;
        this.update();
    }

    private setState(state: HeaderState) {
        const isNewState = this.state !== state;
        if (isNewState) {
            this.state = state;
            this.update();
        }
    }

    private update() {
        this.header.setAttribute(this.headerStateAttribute, this.state);
    }

    public hide() {
        this.setState(HeaderState.HIDDEN);
    }

    public show() {
        if (this.hasScrolled()) {
            this.setState(HeaderState.COLLAPSED);
        } else {
            this.setState(HeaderState.OPEN);
        }
    }

    private hasScrolled() {
        return window.scrollY > 0;
    }
}